<template>
<div>
    <rkm-form
        ref="Form"
        show-legend
    >

        <rkm-area
            title="Laboratório"
            type="fieldset"
        >

            <rkm-row>
                <rkm-col cols="6">
                    <rkm-form-select
                        :options="data.form.unidades"
                        label="Laboratório"
                        show-default-option
                        text-field="nomeFantasia"
                        v-model="item.unidadeId"
                        disabled
                        value-field="id"
                    />
                </rkm-col>

                <rkm-col cols="6">
                    <rkm-form-select
                        label="Local de atendimento"
                        :options="infraestruturas"
                        textField="nome"
                        v-model="item.infraestruturaId"
                        disabled
                        valueField="id"
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-input
                        label="Tipo"
                        v-model="item.cotaTipoNome"
                        disabled
                    />
                </rkm-col>

                <rkm-col class="flex-grow-1" v-show="item.cotaTipoId == enums.tipoCota.QUANTIDADE">
                    <rkm-form-input
                        label="Cota"
                        v-model="item.cotaQuantidade"
                        number
                        disabled
                    />
                </rkm-col>

                <rkm-col class="flex-grow-1" v-show="item.cotaTipoId != enums.tipoCota.QUANTIDADE">
                    <rkm-form-input
                        label="Cota"
                        ref="cotaValor"
                        v-model="item.cotaValor"
                        v-money="money"
                        prepend="R$"
                        disabled
                    />
                </rkm-col>

                <rkm-col cols="6">
                    <rkm-form-date-picker
                        range
                        :range-inline="false"
                        start-label="Período de"
                        end-label="Até"
                        v-model="model.periodo"
                        disabled
                    />
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <rkm-row>

            <rkm-col
                cols="12"
            >
                <rkm-area
                    :title="checkHandleAlter ? 'Alterar cota - Exames' : 'Cadastrar cota - Exames'"
                    type="fieldset"
                >

                    <rkm-row>

                        <rkm-col cols="8">
                            <rkm-form-select
                                :options="listExames"
                                :validations="validations.exame"
                                label="Exame"
                                show-default-option
                                text-field="nome"
                                v-model="exame.exameId"
                                value-field="id"
                            />
                        </rkm-col>

                        <rkm-col class="flex-grow-1" v-show="item.cotaTipoId == enums.tipoCota.QUANTIDADE">
                            <rkm-form-input
                                label="Cota"
                                v-model="exame.cotaQuantidade"
                                :validations="item.cotaTipoId == enums.tipoCota.QUANTIDADE ? validations.cotaQuantidade : {}"
                                number
                            />
                        </rkm-col>

                        <rkm-col class="flex-grow-1" v-show="item.cotaTipoId != enums.tipoCota.QUANTIDADE">
                            <rkm-form-input
                                label="Cota"
                                ref="itemCotaValor"
                                v-model="exame.cotaValor"
                                :validations="item.cotaTipoId == enums.tipoCota.VALOR ? validations.cotaValor : {}"
                                v-money="money"
                                prepend="R$"
                            />
                        </rkm-col>

                        <rkm-col class="flex-grow-0" v-if="checkHandleAlter">

                            <rkm-button
                                :label="false"
                                color="secondary"
                                @click.stop="hideAlter()"
                            >
                                Voltar
                            </rkm-button>
                        </rkm-col>

                        <rkm-col class="flex-grow-0" >

                            <rkm-button
                                :label="false"
                                color="primary"
                                @click.stop="handleCota({exameId: exame.exameId})"
                            >
                                {{ checkHandleAlter ? 'Alterar' : 'Incluir' }}
                            </rkm-button>
                        </rkm-col>
                    </rkm-row>
                </rkm-area>

                    <List
                        v-if="!checkHandleAlter"
                        :data="data"
                        :cotalaboratorio="item"
                        :exames="item.exames"
                        :indexExame="indexExame"
                        :unidadeId="item.unidadeId"
                        :infraestruturaId="item.infraestruturaId"
                        :examesum="this.examesum"
                        :cotaTipoId="this.item.cotaTipoId"
                        @handleAlter="handleAlter"
                        @checkSum="checkSum"
                        @save="save"
                    />
            </rkm-col>
        </rkm-row>
    </rkm-form>
</div>
</template>

<script>
// Vuex.
import { mapActions } from 'vuex'

// Components.
import List from './List'

// Mixins.
import { repository, object, data, formats } from '@/mixins'

// Moment.
import moment from 'moment'

// Enums.
import tipoCota from '@/enums/exame-laboratorial/tipoCota'

//Directives
import { VMoney } from 'v-money'

export default {
    components: { List },
    directives: { money: VMoney },
    computed: {
        validations() {

            return {
                exame: { required: true },
                cotaQuantidade: { required: true },
                cotaValor: { max: 13, min_value: 0.01  },
            }
        },
        hasIndex() {

            return this.index !== null
        },
        infraestruturas() {

            if (this.item.unidadeId) {

                return this.data.form.unidades.find(u => u.id === this.item.unidadeId).infraestruturas
            }

            return []
        },
    },
    created() {

        this.repositories = {
            saldo: this.getConectaSusRepository('exameLaboratorial.parametrizacao')
        }

        this.load()
    },
    data: () => ({
        form: {
            exames: {},
        },
        exames: [],
        listExames: [],
        exame: {
            exameId: null,
            cotaExamePeriodoId: null,
            cota: '0',
            cotaValor: '0',
            cotaQuantidade: '0',
            unidadeSolicitante: [],
            transferido: null,
            cotaQuantidadeTransferido: null,
            cotaValorTransferido: null,
            valorUtilizado: '0',
            quantidadeUtilizada: '0',
        },
        enums: {
            tipoCota
        },
        model: {
            periodo: {
                start: null,
                end: null
            },
        },
        money: {
          decimal: ',',
          thousands: '.',
          prefix: '',
          suffix: '',
          precision: 2,
          masked: false
        },
        isReadOnly: false,
        checkHandleAlter: false,
        index: null,
        examesum: 0,
        cotaOld: null,
        examePeriodo: null,
        dataInicioExame: null,
        dataFimExame: null,
        cotasAtribuidas: null,
        cotaAtribuida: null,
        atribuiNovaCota: null,
        limiteCota: false,
        examePeriodoId: null,
        addCota: false,
        cotaAtribuidaUnidade: null,
        utilizada: 0,
        utilizadas: 0,
        saldoUtilizadas: 0,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.model.periodo.start = moment(
                this.item.periodo.start,
                'DD/MM/YYYY'
            ).toDate()

            this.model.periodo.end = moment(
                this.item.periodo.end,
                'DD/MM/YYYY'
            ).toDate()

            this.item.exames.map(saldo => {

                if (this.item.cotaTipoId == this.enums.tipoCota.VALOR) {

                   this.examesum = this.examesum + this.formatSumMoney(saldo.cota);
                } else {
                   this.examesum = this.examesum + Number(saldo.cota);
                }
            })

            this.handleExames()
        },
        handleExames() {

            let exames = []

            this.data.model.cotasExamePeriodo.filter((unidade) => unidade.unidadeId == this.item.unidadeId
                && unidade.infraestruturaId == this.item.infraestruturaId
                && unidade.cotaTipoId == this.item.cotaTipoId)
                    .forEach(exame => {

                        if (exame.exames.length > 0) {

                            exame.exames.forEach(item => {

                                exames.push({
                                    id: item.exameId,
                                    nome: item.exameNome,
                                    examePeriodoId: item.id,
                                    periodo: item.periodo,
                                    cota: item.cota,
                                    cotaTipoId: item.cotaTipoId,
                                    infraestruturaId: item.infraestruturaId
                                })
                            })
                        } else {

                            this.getCotaExame(exame).then(cotaExames => {
                                if (cotaExames.length > 0) {
                                    cotaExames.forEach(item => {
                                        exames.push({
                                            id: item.exameId,
                                            nome: item.exameNome,
                                            examePeriodoId: item.id,
                                            periodo: item.periodo,
                                            cota: item.cota,
                                            cotaTipoId: item.cotaTipoId,
                                            infraestruturaId: item.infraestruturaId
                                        });
                                    });
                                }
                            });
                        }
                    })

            this.listExames = exames
        },
        add() {

            this.resetCotas()

            if (this.item.exames.find((s) => s.exameId === this.exame.exameId && s.id != this.exame.id)) {

                this.showValidationNotification('Exame já cadastrado')

                return false
            }

            this.getTotalExame()

            if (!this.limiteCota) {

                this.showValidationNotification('A cota ultrapassa o limite definido por período para o exame.')

                return false
            }

            if (!this.addCota) {

                this.showValidationNotification('A cota ultrapassa o saldo atual por período para o este exame.')

                return false
            }

            const exameNome = this.listExames.find(s => s.id === this.exame.exameId).nome
            const unidadeNome = this.data.form.unidades.find(s => s.id === this.item.unidadeId).nomeFantasia
            const infraestruturaNome = this.infraestruturas.find(s => s.id === this.item.infraestruturaId).nome

            let utilizadas = this.utilizadas
            let cotaValor = this.model.cota

            if (this.item.cotaTipoId == this.enums.tipoCota.VALOR) {

                utilizadas = this.utilizadas.replace('.','').replace(',','.')
                cotaValor = this.model.cota.replace('.','').replace(',','.')

                if (parseFloat(utilizadas) > parseFloat(cotaValor)) {

                    this.showValidationNotification(`A cota é menor que a soma dos exames
                        <strong>(${exameNome})</strong> agendados para o laboratório
                        <strong>${unidadeNome}</strong> e o local de
                        atendimento <strong>${infraestruturaNome}</strong> no período de
                        <strong>${this.getFormatedDate(this.model.periodo.start, 'DD/MM/YYYY')} até
                        ${this.getFormatedDate(this.model.periodo.end, 'DD/MM/YYYY')}</strong>.
                        A cota deve ser maior ou igual a <strong>R$ ${this.utilizadas}</strong>.
                        `)

                    return false
                }
            } else {

                if (parseFloat(utilizadas) > parseFloat(cotaValor)) {

                    this.showValidationNotification(`A cota é menor que a soma dos exames
                        <strong>(${exameNome})</strong> agendados para o laboratório
                        <strong>${unidadeNome}</strong> e o local de
                        atendimento <strong>${infraestruturaNome}</strong> no período de
                        <strong>${this.getFormatedDate(this.model.periodo.start, 'DD/MM/YYYY')} até
                        ${this.getFormatedDate(this.model.periodo.end, 'DD/MM/YYYY')}</strong>.
                        A cota deve ser maior ou igual a <strong>${this.utilizadas}</strong>.
                        `)

                    return false
                }
            }

            if (this.hasIndex) {

                this.item.exames.map(saldo => {

                    if (saldo.exameId == this.exame.exameId) {

                        saldo.unidadeSolicitante.map(unidadeSolicitante => {

                            if (this.item.cotaTipoId == this.enums.tipoCota.VALOR) {

                            this.cotaAtribuidaUnidade = this.cotaAtribuidaUnidade + this.formatSumMoney(unidadeSolicitante.cota);
                            } else {

                            this.cotaAtribuidaUnidade = this.cotaAtribuidaUnidade + Number(unidadeSolicitante.cota);
                            }
                        })
                    }
                })

                if (this.item.cotaTipoId == this.enums.tipoCota.VALOR) {

                    if (this.formatSumMoney(this.exame.cotaValor) < this.cotaAtribuidaUnidade) {

                        this.showValidationNotification(`O valor da cota informada está menor que o valor das cotas já
                            atribuídas. A cota deve ser maior ou igual a <strong>R$
                            ${this.formatMoney(parseFloat(this.cotaAtribuidaUnidade), 2)}</strong>.`)

                        return false
                    }

                } else {

                    if (this.exame.cotaQuantidade < this.cotaAtribuidaUnidade) {

                        this.showValidationNotification(`O valor da cota informada está menor que o valor das cotas já
                            atribuídas. A cota deve ser maior ou igual a <strong>
                            ${this.formatMoney(parseFloat(this.cotaAtribuidaUnidade),0)}</strong>.`)

                        return false
                    }
                }
            }

            const exame = this.clone(this.exame)

            exame.exameId = this.exame.exameId
            exame.cotaExamePeriodoId = this.examePeriodoId

            if (this.hasIndex) {

                if (this.item.cotaTipoId == this.enums.tipoCota.VALOR) {

                    this.examesum = this.examesum - this.formatSumMoney(this.cotaOld);
                } else {

                    this.examesum = this.examesum - Number(this.cotaOld);
                }
            }

            if (this.item.cotaTipoId == this.enums.tipoCota.VALOR) {

                exame.cota = this.exame.cotaValor
            } else {

                exame.cota = this.exame.cotaQuantidade
            }

            if (this.item.cotaTipoId == this.enums.tipoCota.VALOR) {

                this.examesum = this.examesum + this.formatSumMoney(exame.cota);
            } else {

                this.examesum = this.examesum + Number(exame.cota);
            }

            if (this.item.cotaTipoId == this.enums.tipoCota.VALOR) {

                if (this.exame.cotaValor.length == 0 || this.exame.cotaValor == '0,00') {

                    this.showValidationNotification('Obrigatório informar a cota e o valor deve ser maior que zero.')

                    return false
                }
            }

            if (this.item.cotaTipoId == this.enums.tipoCota.QUANTIDADE) {

                if (this.examesum > this.item.cotaQuantidade) {

                    this.examesum = this.examesum - Number(exame.cota);

                    if (this.hasIndex) {

                        this.examesum = this.examesum + Number(this.cotaOld);
                    }

                    this.showValidationNotification('A cota ultrapassa o limite definido por período para o laboratório.')

                    return false
                }
            }

            if (this.item.cotaTipoId == this.enums.tipoCota.VALOR) {

                if (this.examesum > this.formatSumMoney(this.item.cotaValor)) {

                    this.examesum = this.examesum - this.formatSumMoney(exame.cota);

                    if (this.hasIndex) {

                        this.examesum = this.examesum + this.formatSumMoney(this.cotaOld);
                    }

                    this.showValidationNotification('O limite da cota foi atingido.')

                    return false
                }
            }

            exame.nome = this.data.form.exames.find(s => s.id === this.exame.exameId).nome

            if (this.hasIndex) {

            const index = this.item.exames.findIndex((s) => s.exameId === this.exame.exameId)

                this.$set(this.item.exames, index, this.clone(exame))
                this.index = null
                this.checkHandleAlter = false
            } else {

                this.item.exames.push(exame)
            }

            this.$emit('save')

            this.resetForm()
        },
        getTotalExame() {

            const item = this.listExames.find(unidade => unidade.id == this.exame.exameId)

            if (!this.dataInicioExame) {

                this.dataInicioExame = item.periodo.start.split("/").reverse().join("-")
            } else {

                if (moment(item.periodo.start.split("/").reverse().join("-")).isBefore(this.dataInicioExame)) {

                    this.dataInicioExame = item.periodo.start.split("/").reverse().join("-")
                }
            }

            if (!this.dataFimExame) {

                this.dataFimExame = item.periodo.end.split("/").reverse().join("-")
            } else {

                if (moment(item.periodo.end.split("/").reverse().join("-")).isAfter(this.dataFimExame)) {

                    this.dataFimExame = item.periodo.end.split("/").reverse().join("-")
                }
            }

            if (this.item.cotaTipoId == this.enums.tipoCota.QUANTIDADE) {

                if (item.cota) {

                    this.examePeriodo = Number(item.cota);
                }

            } else {

                if (item.cota) {

                    this.examePeriodo = this.formatSumMoney(item.cota);
                }
            }

            if (this.item.cotaTipoId == this.enums.tipoCota.VALOR) {

                if (this.examePeriodo) {

                    if (this.formatSumMoney(this.exame.cotaValor) <= this.examePeriodo) {

                        this.limiteCota = true
                        this.examePeriodoId = item.id
                    }
                }

            } else {

                if (this.examePeriodo) {

                    if (this.exame.cotaQuantidade <= this.examePeriodo) {

                        this.limiteCota = true
                        this.examePeriodoId = item.id
                    }
                }
            }

            if (this.examePeriodo && this.limiteCota == true && this.addCota == false) {

                this.getCotaAtribuida(this.examePeriodoId)
            }
        },
        getCotaAtribuida(examePeriodo) {

            this.cotasAtribuidas = 0

            this.data.model.cotasLaboratorio.find((unidade) => unidade.unidadeId == this.item.unidadeId
                && unidade.infraestruturaId == this.item.infraestruturaId).cotaLaboratorio.filter(field => moment(

                    field.periodo.start.split("/").reverse().join("-")
                )
                .isBetween(
                    this.dataInicioExame,
                    this.dataFimExame,
                    null,
                    '[]'
                )
                && moment(
                    field.periodo.end.split("/").reverse().join("-")
                )
                .isBetween(
                    this.dataInicioExame,
                    this.dataFimExame,
                    null,
                    '[]'
                )
            ).map(exame => {

                this.cotaAtribuida = exame.exames.filter(field => field.exameId == this.exame.exameId
                    && field.cotaExamePeriodoId == examePeriodo).reduce((sum, element) => {

                    if (this.item.cotaTipoId == this.enums.tipoCota.VALOR) {

                        if (element.cota) {

                            sum = sum + this.formatSumMoney(element.cota);
                        }
                    } else {

                        if (element.cota) {

                            sum = Number(sum) + Number(element.cota);
                        }
                    }

                    return sum
                },0)

                    if (this.item.cotaTipoId == this.enums.tipoCota.VALOR) {

                        this.cotasAtribuidas = this.cotasAtribuidas + this.cotaAtribuida
                    } else {
                        this.cotasAtribuidas = this.cotasAtribuidas + this.cotaAtribuida
                    }

                }
            )

            if (this.item.cotaTipoId == this.enums.tipoCota.VALOR) {

                if (this.hasIndex) {

                    this.atribuiNovaCota =  (this.cotasAtribuidas + this.formatSumMoney(this.exame.cotaValor)) - this.formatSumMoney(this.cotaOld)

                } else {

                    this.atribuiNovaCota =  this.cotasAtribuidas + this.formatSumMoney(this.exame.cotaValor)
                }

            } else {

                if (this.hasIndex) {

                    this.atribuiNovaCota =  (this.cotasAtribuidas + Number(this.exame.cotaQuantidade)) - Number(this.cotaOld)

                } else {

                    this.atribuiNovaCota =  this.cotasAtribuidas + Number(this.exame.cotaQuantidade)
                }
            }

            if (this.examePeriodo >= this.atribuiNovaCota) {

                this.addCota = true
            }
        },
        handleCota(item) {

            this.setLoading()

            const data = this.item

            this.repositories.saldo.saldoExame({
                unidade_id: this.item.unidadeId,
                infraestrutura_id: this.item.infraestruturaId,
                exame_id: item.exameId,
                inicio: this.getFormatedDate(this.model.periodo.start, 'YYYY-MM-DD'),
                fim: this.getFormatedDate(this.model.periodo.end, 'YYYY-MM-DD'),
            })
                .then(response => {

                    if (this.item.cotaTipoId == this.enums.tipoCota.VALOR) {

                        this.model.cota = this.exame.cotaValor
                    } else {

                        this.model.cota = this.exame.cotaQuantidade
                    }

                    item.cota = this.model.cota

                    this.getCotaUtilizada(data, response.data, item)

                    this.$refs.Form.validate(this.add)

                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getCotaUtilizada(cotaExamePeriodo, items, item) {

            this.cotasAtribuidas = 0
            this.cotaAtribuida = 0

            const cota = items.cotasLaboratorio.find((unidade) => unidade.unidadeId == cotaExamePeriodo.unidadeId
                && unidade.infraestruturaId == cotaExamePeriodo.infraestruturaId)

            if (cota) {

                cota.cotaLaboratorio.filter(field => field.cotaTipoId == cotaExamePeriodo.cotaTipoId
                    && moment(
                        field.periodo.start.split("/").reverse().join("-")
                    )
                    .isBetween(
                        this.getFormatedDate(this.model.periodo.start, 'YYYY-MM-DD'),
                        this.getFormatedDate(this.model.periodo.end, 'YYYY-MM-DD'),
                        null,
                        '[]'
                    )
                    && moment(
                        field.periodo.end.split("/").reverse().join("-")
                    )
                    .isBetween(
                        this.getFormatedDate(this.model.periodo.start, 'YYYY-MM-DD'),
                        this.getFormatedDate(this.model.periodo.end, 'YYYY-MM-DD'),
                        null,
                        '[]'
                    )
                ).map(exame => {

                    this.cotaAtribuida = exame.exames.filter(field => field.exameId == cotaExamePeriodo.exameId)
                        .reduce((sum, element) => {

                            if (cotaExamePeriodo.cotaTipoId == this.enums.tipoCota.VALOR) {

                                if (element.cota) {

                                    sum = sum + this.formatSumMoney(element.cota);
                                }
                            } else {

                                if (element.cota) {

                                    sum = Number(sum) + Number(element.cota);
                                }
                            }

                            return sum
                        },0)

                    this.cotasAtribuidas = this.cotasAtribuidas + this.cotaAtribuida
                })
            }

            if (cotaExamePeriodo.cotaTipoId == this.enums.tipoCota.VALOR) {

                this.cotasAtribuidas = this.formatMoney(this.cotasAtribuidas, 2)
                this.saldoAtribuidas = this.formatSumMoney(item.cota) - this.formatSumMoney(this.cotasAtribuidas)
                this.saldoAtribuidas = this.formatMoney(this.saldoAtribuidas, 2)
                let valorAgendado = this.formatMoney(parseFloat(items.valorAgendado), 2)

                if (this.cotasAtribuidas > 0 || this.cotasAtribuidas > '0,00') {

                    this.saldoUtilizadas = this.formatSumMoney(this.cotasAtribuidas) - this.formatSumMoney(valorAgendado)
                    this.saldoUtilizadas = this.formatMoney(this.saldoUtilizadas, 2)
                    this.utilizadas = this.formatMoney(parseFloat(items.valorAgendado), 2)
                } else {

                    this.saldoUtilizadas = this.formatMoney(this.saldoUtilizadas, 2)
                    this.utilizadas = this.formatMoney(parseFloat(items.valorAgendado), 2)
                }
            } else {

                this.saldoAtribuidas = item.cota - Number(this.cotasAtribuidas)
                this.saldoAtribuidas = this.formatMoney(this.saldoAtribuidas, 0)
                this.cotasAtribuidas = this.formatMoney(this.cotasAtribuidas, 0)

                this.utilizadas = items.quantidadeAgendada

                if (this.cotasAtribuidas > 0) {

                    this.saldoUtilizadas = this.cotasAtribuidas - Number(this.utilizadas)
                    this.saldoUtilizadas = this.formatMoney(this.saldoUtilizadas, 0)
                }
            }
        },
        handleAlter(index, item) {

            this.resetForm()

            this.index = index
            this.exame.id = item.id
            this.exame.exameId = item.exameId
            this.exame.cotaQuantidade = item.cotaQuantidade
            this.exame.cotaValor = item.cotaValor
            this.exame.unidadeSolicitante = item.unidadeSolicitante
            this.exame.valorUtilizado = item.valorUtilizado
            this.exame.quantidadeUtilizada = item.quantidadeUtilizada

            if (this.item.cotaTipoId == this.enums.tipoCota.VALOR) {
              this.cotaOld = item.cotaValor
            } else {
               this.cotaOld = item.cotaQuantidade
            }

            this.$refs.itemCotaValor.$el.getElementsByTagName('input')[0].value = item.cotaValor;

            this.checkHandleAlter = true
        },
        hideAlter() {

            this.checkHandleAlter = false

            this.resetForm()
        },
        checkSum() {

            this.examesum = 0

            this.item.exames.map(saldo => {

                if (this.item.cotaTipoId == this.enums.tipoCota.VALOR) {

                   this.examesum = this.examesum + this.formatSumMoney(saldo.cota);
                } else {
                   this.examesum = this.examesum + Number(saldo.cota);
                }
            })
        },
        hasUnidadeParametrizada() {

            return this.data.model.cotasExamePeriodo.find((unidade, i) => i !== this.index
                && unidade.exameId == this.model.exameId && unidade.ano == this.model.ano)
        },
        handleDestroy(index, item) {

            const destroy = async () => {

                this.exames.splice(index, 1)
            }

            this.showDeleteConfirmation(`Deseja realmente excluir a cota para o exame
                <strong>${ item.nome }</strong>?`,
                destroy)
        },
        resetForm() {

            this.index = null
            this.exame.exameId = null
            this.exame.cotaValor= ''
            this.$refs.itemCotaValor.$el.getElementsByTagName('input')[0].value = 0;
            this.exame.cotaQuantidade= ''
            this.$nextTick(() => this.$refs.Form.resetValidator())
        },
        resetCotas() {

            this.examePeriodo = null
            this.cotasAtribuidas = null
            this.cotaAtribuida = null
            this.cotaAtribuidaUnidade = null
            this.limiteCota = false
            this.examePeriodoId = null
            this.addCota = false
        },
        save() {

            this.$emit('save')
        },
        getCotaExame(item) {

            this.setLoading();

            let inicio = item.periodo.start;
            let fim = item.periodo.end;

            return this.repositories.saldo.getCotaExame({
                infraestrutura_id: item.infraestruturaId,
                cota_tipo_id: item.cotaTipoId,
                inicio: this.getFormatedDate(inicio, 'YYYY-MM-DD', 'DD/MM/YYYY'),
                fim: this.getFormatedDate(fim, 'YYYY-MM-DD', 'DD/MM/YYYY'),
            })
                .then(response => {
                    return response.data;
                })
                .catch(error => {
                    this.handleError(error);
                    return [];
                })
                .finally(() => this.unsetLoading());
        }
    },
    mixins: [repository, object, data, formats],
    props: {
        data: { type: Object, required: true },
        item: { type: Object, required: true },
        indexExame: { type: [Number, String], required: true },
    },
}
</script>